"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiError = exports.ApiErrorName = void 0;
exports.ApiErrorName = 'ApiError';
/**
 * ApiError class
 * @param message Error message
 * @param error Error object
 */
class ApiError extends Error {
    constructor(message, status, response) {
        super();
        this.response = null;
        this.status = null;
        this.name = exports.ApiErrorName;
        this.message = message || '';
        this.response = response || null;
        this.status = status;
    }
}
exports.ApiError = ApiError;
//# sourceMappingURL=ApiError.js.map